import { h } from "preact";
import { useState, useEffect, useRef } from "preact/hooks";
import { Box, Button } from "@mui/material";
import mapboxgl from "mapbox-gl";
import "../../../css/mapbox-gl.css";
mapboxgl.accessToken = "pk.eyJ1IjoidGVsZW1ldGlzIiwiYSI6ImNrcWZvd2c0MzByM2wybnNjOGR2c2JtNGEifQ.npIdy2KCcctfSjvVWcSDXw";

export default function MapBox({ ilat, ilon, pts, zm }) {
  console.log("ilat, ilon", ilon, ilat, pts, zm);

  const mapContainerRef = useRef(null);

  const [lng, setLng] = useState(ilon);
  const [lat, setLat] = useState(ilat);
  const [zoom, setZoom] = useState(zm ? zm : 12);

  // Initialize map when component mounts
  useEffect(() => {
    //console.log("init map")
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: zoom,
    });

    // pts.map((p) => {
    //   const el = document.createElement('div');
    //   const width = 20;
    //   const height = 20;
    //   el.className = 'marker';
    //   el.style.backgroundImage = `url(https://placekitten.com/g/${width}/${height}/)`;
    //   el.style.width = `${width}px`;
    //   el.style.height = `${height}px`;
    //   el.style.backgroundSize = '100%';

    //   el.addEventListener('click', () => {
    //     window.alert(p.adr1);
    //   });
    //   console.log("add markers", p)
    //   // Add markers to the map.
    //   new mapboxgl.Marker()
    //     .setLngLat([p.lon, p.lat]).addTo(map);
    // })

    // Add navigation control (the +/- zoom buttons)
    // map.addControl(new mapboxgl.NavigationControl(), "top-right");

    // console.log("center", map.getCenter().lng.toFixed(4), map.getCenter().lat.toFixed(4));
    // const marker = new mapboxgl.Marker({
    //   color: "#00FF00",
    //   draggable: false,
    // })
    //   .setLngLat([map.getCenter().lng.toFixed(4), map.getCenter().lat.toFixed(4)])
    //   // .setLngLat([ilon, ilat])
    //   .addTo(map);

    // map.on("move", () => {
    //   console.log("onmove");
    //   //setLng(map.getCenter().lng.toFixed(4));
    //   //setLat(map.getCenter().lat.toFixed(4));
    //   setZoom(map.getZoom().toFixed(2));
    // });

    const feat = pts.map((p) => {
      return {
        // feature for Mapbox DC
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [
            p.lon, p.lat
          ]
        },
        'properties': {
          //  'title': p.mnt + ' €'
        }
      }
    })

    map.on("load", () => {
      map.loadImage(
        '/images/bk_loc_tiny.png',
        // 'https://members.bkeys.com/images/bk_loc_tiny.png',
        // 'https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png',
        (error, image) => {
          if (error) throw error;
          map.addImage('custom-marker', image);
          // Add a GeoJSON source with 2 points

          map.addSource('points', {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': feat
              // [
              //   {
              //     // feature for Mapbox DC
              //     'type': 'Feature',
              //     'geometry': {
              //       'type': 'Point',
              //       'coordinates': [
              //         -77.03238901390978, 38.913188059745586
              //       ]
              //     },
              //     'properties': {
              //       'title': 'Mapbox DC'
              //     }
              //   },
              //   {
              //     // feature for Mapbox SF
              //     'type': 'Feature',
              //     'geometry': {
              //       'type': 'Point',
              //       'coordinates': [-122.414, 37.776]
              //     },
              //     'properties': {
              //       'title': 'Mapbox SF'
              //     }
              //   }
              // ]
            }
          });

          // Add a symbol layer
          map.addLayer({
            'id': 'points',
            'type': 'symbol',
            'source': 'points',
            'layout': {
              'icon-image': 'custom-marker',
              // get the title name from the source's "title" property
              'text-field': ['get', 'title'],
              'text-font': [
                'Open Sans Semibold',
                'Arial Unicode MS Bold'
              ],
              'text-offset': [0, 1.25],
              'text-anchor': 'top'
            }
          });

        }
      );
    })
    // Clean up on unmount
    return () => map.remove();
  }, [ilon, pts]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div style={{
    // position: 'absolute',
    // top: 0,
    //bottom: 0,
    width: '100%',
    height: '400px',
  }}
    ref={mapContainerRef} />;
  //return <div style="width: 100%; max-height: 500px;" ref={mapContainerRef} />;
}
